<template>
  <v-select
    v-model="selected"
    :items="items"
    item-value="id"
    item-text="label"
    chips
    outlined
    dense
    :clearable="clearable"
    :label="isMyGroups ? 'My Groups' : 'Groups'"
    multiple
    menu-props="auto, overflowX, overflowY"
    hide-details
    @change="$emit('select-item', selected)"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    initGroups: {
      type: Array,
      default: () => []
    },
    isMyGroups: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: []
    }
  },
  computed: {
    ...mapGetters([ 'allGroups', 'filteredGroups', 'getUserGroups' ]),
    items() {
      return this.isMyGroups
        ? this.filteredGroups(this.getUserGroups)
        : this.allGroups
    }
  },
  watch: {
    initGroups() {
      this.selected = [ ...this.initGroups ]
    }
  },
  mounted() {
    this.selected = [ ...this.initGroups ]
  },
  created() {
    this.$store.dispatch('initGroups')
  }
}
</script>
